import React from 'react'
import { ShoppingCart, Briefcase, GraduationCap, Heart, Building2, Headphones } from 'lucide-react'

const UseCasesSection = () => {
  const useCases = [
    {
      icon: ShoppingCart,
      title: 'E-Commerce',
      description: 'Handle product inquiries, order tracking, and returns 24/7. Boost sales with personalized recommendations.',
      stats: '40% increase in conversions'
    },
    {
      icon: Briefcase,
      title: 'Professional Services',
      description: 'Schedule appointments, answer FAQs, and qualify leads automatically while you focus on clients.',
      stats: '60% time saved on admin'
    },
    {
      icon: GraduationCap,
      title: 'Education',
      description: 'Support students with course information, enrollment assistance, and 24/7 academic guidance.',
      stats: '85% student satisfaction'
    },
    {
      icon: Heart,
      title: 'Healthcare',
      description: 'Appointment scheduling, symptom checking, and patient support with HIPAA-compliant security.',
      stats: '50% fewer missed appointments'
    },
    {
      icon: Building2,
      title: 'Real Estate',
      description: 'Qualify leads, schedule property viewings, and answer questions about listings instantly.',
      stats: '3x more qualified leads'
    },
    {
      icon: Headphones,
      title: 'Customer Support',
      description: 'Resolve common issues instantly, escalate complex cases, and maintain conversation history.',
      stats: '70% faster resolution time'
    }
  ]

  return (
    <section data-component-path="client/src/components/home/UseCasesSection.jsx" data-component-line="50:4" data-component-id="client/src/components/home/UseCasesSection.jsx:50:4" className="py-20 bg-gray-50">
      <div data-component-path="client/src/components/home/UseCasesSection.jsx" data-component-line="51:6" data-component-id="client/src/components/home/UseCasesSection.jsx:51:6" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div data-component-path="client/src/components/home/UseCasesSection.jsx" data-component-line="52:8" data-component-id="client/src/components/home/UseCasesSection.jsx:52:8" className="text-center mb-16">
          <h2 data-component-path="client/src/components/home/UseCasesSection.jsx" data-component-line="53:10" data-component-id="client/src/components/home/UseCasesSection.jsx:53:10" className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Built for Every Industry
          </h2>
          <p data-component-path="client/src/components/home/UseCasesSection.jsx" data-component-line="56:10" data-component-id="client/src/components/home/UseCasesSection.jsx:56:10" className="text-xl text-gray-600 max-w-3xl mx-auto">
            From startups to enterprises, our AI agents adapt to your unique business needs
          </p>
        </div>

        <div data-component-path="client/src/components/home/UseCasesSection.jsx" data-component-line="61:8" data-component-id="client/src/components/home/UseCasesSection.jsx:61:8" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {useCases.map((useCase, index) => {
            const Icon = useCase.icon
            return (
              <div data-component-path="client/src/components/home/UseCasesSection.jsx" data-component-line="65:14" data-component-id="client/src/components/home/UseCasesSection.jsx:65:14"
                key={index}
                className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100"
              >
                <div data-component-path="client/src/components/home/UseCasesSection.jsx" data-component-line="69:16" data-component-id="client/src/components/home/UseCasesSection.jsx:69:16" className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                  <Icon data-component-path="client/src/components/home/UseCasesSection.jsx" data-component-line="70:18" data-component-id="client/src/components/home/UseCasesSection.jsx:70:18" className="w-8 h-8 text-blue-600" />
                </div>
                <h3 data-component-path="client/src/components/home/UseCasesSection.jsx" data-component-line="72:16" data-component-id="client/src/components/home/UseCasesSection.jsx:72:16" className="text-2xl font-semibold text-gray-900 mb-3">
                  {useCase.title}
                </h3>
                <p data-component-path="client/src/components/home/UseCasesSection.jsx" data-component-line="75:16" data-component-id="client/src/components/home/UseCasesSection.jsx:75:16" className="text-gray-600 mb-4 leading-relaxed">
                  {useCase.description}
                </p>
                <div data-component-path="client/src/components/home/UseCasesSection.jsx" data-component-line="78:16" data-component-id="client/src/components/home/UseCasesSection.jsx:78:16" className="inline-flex items-center gap-2 bg-green-50 text-green-700 px-4 py-2 rounded-lg text-sm font-medium">
                  <span data-component-path="client/src/components/home/UseCasesSection.jsx" data-component-line="79:18" data-component-id="client/src/components/home/UseCasesSection.jsx:79:18" className="text-lg">📈</span>
                  {useCase.stats}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default UseCasesSection